<template>
  <v-dialog
    :model-value="true"
    width="950"
    @update:modelValue="onCerrarDialog"
  >
    <v-card>

      <!-- Toolbar -->
      <v-toolbar color="primary-accent" density="compact">
        <v-toolbar-title class="text-center">
          <span class="titulo-dialogo raleway-light">
            Historial – {{ formatearFecha(fecha) }}
          </span>
        </v-toolbar-title>
      </v-toolbar>

      <!-- Selección de turno -->
      <v-card-text>
        <div class="d-flex justify-center mb-3">
          <v-btn
            :color="turnoActivo === 'AB' ? 'primary' : 'grey'"
            class="mr-2"
            @click="cargar('AB')"
          >
            Turno AB
          </v-btn>

          <v-btn
            :color="turnoActivo === 'CD' ? 'primary' : 'grey'"
            @click="cargar('CD')"
          >
            Turno CD
          </v-btn>
        </div>

        <v-divider class="mb-3" />

        <!-- Loading -->
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
          class="mb-2"
        />

        <!-- Tabla -->
        <v-table
          v-if="historial.length"
          density="compact"
          fixed-header
          height="420"
        >
          <thead>
            <tr>
              <th>Habitación</th>
              <th>Lado</th>
              <th>Estado</th>
              <th>Cliente</th>
              <th>Turno</th>
              <th>Grupo</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(cama, i) in historial" :key="i">
              <td>{{ cama.room_numero_hab }}</td>
              <td>{{ cama.lado }}</td>
              <td>
                <v-chip
                  size="small"
                  label
                  :color="colorEstado(cama.estado)"
                  variant="flat"
                  class="textoNegro(cama.estado) ? 'text-black' : 'text-white'"
                >
                  {{ cama.estado }}
                </v-chip>
              </td>
              <td>
                {{
                  cama.cliente
                    ? cama.cliente.name + ' ' + cama.cliente.f_lastname
                    : ''
                }}
              </td>
              <td>{{ cama.cliente?.turno || '' }}</td>
              <td>{{ cama.cliente?.grupo || '' }}</td>
            </tr>
          </tbody>
        </v-table>

        <!-- Sin datos -->
        <div
          v-else-if="!loading && turnoActivo"
          class="text-center text-medium-emphasis mt-6"
        >
          No hay datos para este turno
        </div>

      </v-card-text>

      <!-- Acciones -->
      <v-card-actions class="justify-end">
       <v-tooltip text="Exportar PDF" location="top">
        <template #activator="{ props }">
            <v-btn
            v-bind="props"
            icon
            color="blue-darken-3"
            variant="flat"
            class="rounded-circle"
            :disabled="!turnoActivo"
            @click="exportarPdf"
            >
            <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
        </template>
        </v-tooltip>
        <v-btn color="error" variant="tonal" @click="$emit('cerrar')">
          Cerrar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import historial from "@/services/historial";
import  pdfGenerator  from "@/helpers/pdfGenerator";

export default {
  emits: ['cerrar'],
  props: {
    fecha: String
  },
  data() {
    return {
      historial: [],
      loading: false,
      turnoActivo: null
    };
  },
  computed:{
    turno() {
        return this.turnoActivo;
    }
  },
  methods: {
    async cargar(turno) {
      this.turnoActivo = turno;
      this.loading = true;

      try {
        const res = await historial.obtenerHistorialPorFechaYTurno(
          this.fecha,
          turno
        );
        this.historial = res.data?.beds || [];
      } catch (error) {
        console.error("Error cargando historial", error);
      } finally {
        this.loading = false;
      }
    },

    onCerrarDialog(valor) {
      if (!valor) {
        this.$emit('cerrar');
      }
    },

    formatearFecha(fecha) {
      const [y, m, d] = fecha.split('-');
      return `${d}/${m}/${y}`;
    },

    colorEstado(estado) {
        switch (estado) {
            case 'Ocupada':
                return 'red';
            case 'Reservada':
                return 'yellow';
            case 'Libre':
                return 'green';
            case 'No Disp.':
                return 'grey';
            default:
                return 'orange';
        }
    },
    textoNegro(estado) {
        return ['Reservada', 'No Disp.'].includes(estado) || estado === 'Otro';
    },
    exportarPdf() {
        pdfGenerator.exportToPdfHistorialCamas(this.historial, this.fecha, this.turno);
    }
  }
};
</script>